<fury-page>
    <fury-title class="title">
      <span [@fadeInRight]>{{userId ? 'Update' : 'Add'}} Customer</span>
    </fury-title>
  </fury-page>
  <div fxLayout="column" fxLayoutAlign="start center">
    <div [@fadeInUp] class="card">
      <form [formGroup]="userForm">
        <div class="content" fxLayout="column" fxLayoutGap="8px">
          <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>First Name</mat-label>
              <input matInput placeholder="First Name" (keyup)="restrictSpace($event)" formControlName="firstName">
              <mat-error *ngIf="userForm.controls['firstName'].touched && userForm.controls['firstName'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Last Name</mat-label>
              <input matInput placeholder="Last Name" formControlName="lastName" (keyup)="restrictSpace($event)">
              <mat-error *ngIf="userForm.controls['lastName'].touched && userForm.controls['lastName'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>
          </div>
          <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Role</mat-label>
              <mat-select formControlName="roleId" disabled>
                <mat-option [value]="adminType?.roleId">{{adminType?.title}}</mat-option>
              </mat-select>
              <mat-error *ngIf="userForm.controls['roleId'].touched && userForm.controls['roleId'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Email Id</mat-label>
              <input matInput placeholder="Email Id" formControlName="emailAddress">
              <mat-error *ngIf="userForm.controls['emailAddress'].touched && userForm.controls['emailAddress'].hasError('required')">
                  This is a required field.</mat-error>
                  <mat-error *ngIf="userForm.controls['emailAddress'].touched && userForm.controls['emailAddress'].hasError('pattern')">
                      Please enter a valid email id.</mat-error>
            </mat-form-field>
          </div>
          <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Phone Number</mat-label>
              <input type="text" matInput placeholder="Phone Number" formControlName="phoneNumber" mask="(000) 000-0000">
              <mat-error *ngIf="userForm.controls['phoneNumber'].touched && userForm.controls['phoneNumber'].hasError('required')">
                  This is a required field.</mat-error>
                  <mat-error *ngIf="userForm.controls['phoneNumber'].touched && userForm.controls['phoneNumber'].hasError('pattern')">
                      Please enter a valid phone number.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Password</mat-label>
              <input [type]="hide ? 'password' : 'text'" matInput placeholder="Password" formControlName="password" autocomplete="new-password">
                <span class="gen_password" (click)="generateStrongPassword()">Generate</span>
                <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
              <mat-error *ngIf="userForm.controls['password'].touched && userForm.controls['password'].hasError('required')">
                  This is a required field.</mat-error>
                  <mat-error *ngIf="userForm.controls['password'].touched && userForm.controls['password'].hasError('pattern')">
                      Please enter strong password.</mat-error>
            </mat-form-field>
          </div>
        
        </div>
        <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          <button (click)="editUser()" class="sub-button" mat-button
                  type="button">{{userId ? 'Update' : 'Add'}}</button>
          <button class="can-button" (click)="this.location.back()" mat-button>Cancel
          </button>
        </div>
       
      </form>
    </div>
  </div>
  
  